import { combineReducers } from 'redux';

import { campaignReducer, campaignInitialState } from './campaignReducer';
import { categoriesReducer, categoriesInitialState } from './categoriesReducer';
import { cartReducer, cartInitialState } from './cartReducer';
import { productsReducer, productsInitialState } from './productsReducer';
import { userReducer, userInitialState } from './userReducer';
import { viewReducer, viewInitialState } from './viewReducer';
import { sortReducer, sortInitialState } from './sortReducer';
import { searchReducer, searchInitialState } from './searchReducer';
import { customizeReducer, customizeInitialState } from './customizeReducer';
import { adminReducer, adminInitialState } from './adminReducer';
import { abTestReducer, abTestInitialState } from './abTestReducer';
import { invoicesReducer, invoicesInitialState } from './invoicesReducer';
import { optimizelyReducer, optimizelyInitialState } from './optimizelyReducer';

export const initialState = {
  campaignState: campaignInitialState,
  categoriesState: categoriesInitialState,
  viewState: viewInitialState,
  productsState: productsInitialState,
  cartState: cartInitialState,
  userState: userInitialState,
  sortState: sortInitialState,
  searchState: searchInitialState,
  customizeState: customizeInitialState,
  adminState: adminInitialState,
  abTestState: abTestInitialState,
  invoicesState: invoicesInitialState,
  optimizelyState: optimizelyInitialState,
};

const reducers = {
  campaignState: campaignReducer,
  categoriesState: categoriesReducer,
  cartState: cartReducer,
  productsState: productsReducer,
  sortState: sortReducer,
  searchState: searchReducer,
  userState: userReducer,
  viewState: viewReducer,
  customizeState: customizeReducer,
  adminState: adminReducer,
  abTestState: abTestReducer,
  invoicesState: invoicesReducer,
  optimizelyState: optimizelyReducer,
};

export default combineReducers(reducers);
